import { render } from "./ChangesSavedIcon.vue?vue&type=template&id=0da5b9d2"
import script from "./ChangesSavedIcon.vue?vue&type=script&lang=js"
export * from "./ChangesSavedIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__